
































import { Component, Vue, Emit } from 'vue-property-decorator'
import { VTable } from '@/components/table'
import constant from '@/utils/constant'

@Component({
  components: { VTable }
})
export default class ExpressDialog extends Vue {
  private show = false
  private data: any = {}

  @Emit('close')
  private close() {
    this.show = false
    this.data = {}
  }

  public async open( data: any) {
    this.show = true
    this.data = data
  }


  private getBusinessTypeTag(st:number){
    const ds = constant.OperLogBusinessType
    const rs = ds.filter(e=>e.value == st)
    if(rs && rs.length > 0){
      return rs[0]
    }
    return {
      label:st,
      value:st
    }
  }

  private getStatusTag(st:number){
    const ds = constant.OperLogStatus
    const rs = ds.filter(e=>e.value == st)
    if(rs && rs.length > 0){
      return rs[0]
    }
    return {
      label:st,
      value:st
    }
  }


}
